import { ButtonVariantType } from '~/types/buttons';
import { IconType } from '../ui/Icons/Icons';
import SVGIcon from '../ui/Icons/SVGIcon';
import { Button } from './buttons/Button';
import { ReactNode } from 'react';

type InformationalBannerProps = {
  variant?: 'accent' | 'accentLight' | 'warning' | 'error';
  cta?: ReactNode;
  extraClasses?: string;
  containerclasses?: string;
  text: string;
  hideTextOnMobile?: boolean;
  icon?: IconType;
  iconFill?: string;
  showCloseButton?: boolean;
  onClose?: () => void;
};

const InformationalBanner = ({
  variant = 'accent',
  cta,
  extraClasses = '',
  containerclasses = 'container fixed-container-md',
  text,
  hideTextOnMobile = false,
  icon,
  iconFill = '#fff',

  showCloseButton = false,
  onClose,
}: InformationalBannerProps) => {
  return (
    <div className={`${variantClassesMap[variant]} w-100 py-3 ${extraClasses}`}>
      <div
        className={`${containerclasses} d-flex ${
          hideTextOnMobile ? 'flex-row' : 'flex-column'
        } flex-md-row justify-content-between align-items-start align-items-md-center`}
      >
        <div className="w-100 d-flex justify-content-between">
          <div className="d-flex align-items-start align-items-md-center">
            {icon && (
              <div>
                <SVGIcon
                  iconType={icon}
                  className="me-2"
                  fill={iconFill}
                />
              </div>
            )}
            <div className={hideTextOnMobile ? 'd-none d-md-block' : ''}>
              <div
                className="text-1"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </div>
          </div>
          {showCloseButton && (
            <Button
              extraClasses="ms-2 d-md-none"
              isIconButton={true}
              variant={variantToIconButtonMap[variant] as ButtonVariantType}
              onClick={onClose}
            >
              <SVGIcon
                iconType="cross"
                fill="#fff"
              />
            </Button>
          )}
        </div>

        {(!!cta || showCloseButton) && (
          <div
            role="button"
            className={`d-flex align-items-center align-self-end align-self-md-center ${
              hideTextOnMobile ? '' : 'mt-3'
            } mt-md-0`}
          >
            {cta}

            {showCloseButton && (
              <Button
                extraClasses="ms-6 d-none d-md-block"
                isIconButton={true}
                size="lg"
                variant={variantToIconButtonMap[variant] as ButtonVariantType}
                onClick={onClose}
              >
                <SVGIcon
                  iconType="cross"
                  fill="#fff"
                />
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const variantClassesMap = {
  accent: 'bg-accent-500 color-white',
  accentLight: 'bg-accent-variation-500 fo-border-bottom-sm border-accent-500',
  warning: 'bg-warning-500',
  error: 'bg-error-500',
};

const variantToIconButtonMap = {
  accent: 'accentGhost',
  //adapt below as needed, currently only accent implemented correctly
  accentLight: 'accentGhost',
  warning: 'accentGhost',
  error: 'accentGhost',
};

export default InformationalBanner;
